document.addEventListener("DOMContentLoaded", function () {
  // Header menu item
  const headerMenuItems = document.querySelectorAll(
    "summary.header__menu-item"
  );
  headerMenuItems.forEach((item) => {
    item.addEventListener("click", function (e) {
      this?.nextElementSibling
        ?.querySelector(".mega-menu__link-product")
        ?.dispatchEvent(new MouseEvent('mouseover', { 'view': window, 'bubbles': true, 'cancelable': true }));
    });
  });

  // Mega menu link
  const megaMenuProductLinks = document.querySelectorAll(
    ".mega-menu__link-product"
  );
  megaMenuProductLinks.forEach((link) => {
    link.addEventListener("mouseover", function (e) {
      e.preventDefault();
      const productCollection = this.getAttribute("data-products");
      const productList = document.querySelectorAll(".mega-menu-products-list");
      productList.forEach((item) => {
        item.classList.remove("active");
      });
      document
        .getElementById(`mega-menu-products-list-${productCollection}`)
        .classList.add("active");
      megaMenuProductLinks.forEach((item) => {
        item.classList.remove("selected");
      });
      this.classList.add("selected");
    });
  });

  
});
